var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 19C21 20.6569 19.6569 22 18 22H6C4.34315 22 3 20.6569 3 19V5C3 3.34315 4.34315 2 6 2H15.7574C15.8386 2 15.9196 2.0033 16 2.00982C16.018 2.01128 16.0359 2.0129 16.0539 2.01468C16.7406 2.08287 17.3864 2.3864 17.8787 2.87868L20.1213 5.12132C20.6265 5.62646 20.9328 6.29318 20.9902 7C20.9902 7.00047 20.9903 7.00093 20.9903 7.0014C20.9967 7.08136 21 7.16183 21 7.24264V19ZM18 21H6C4.89543 21 4 20.1046 4 19V5C4 3.89543 4.89543 3 6 3H15V5C15 6.65685 16.3431 8 18 8H20V19C20 20.1046 19.1046 21 18 21ZM19.9852 6.99998C19.9313 6.55897 19.7316 6.14585 19.4142 5.82843L17.1716 3.58579C16.8668 3.28104 16.4739 3.0848 16.0527 3.02192C16.0352 3.0193 16.0176 3.01692 16 3.01477V5C16 6.10457 16.8954 7 18 7L19.9852 6.99998C19.9852 6.99999 19.9852 6.99997 19.9852 6.99998Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 11C7.5 10.7239 7.72386 10.5 8 10.5H16C16.2761 10.5 16.5 10.7239 16.5 11C16.5 11.2761 16.2761 11.5 16 11.5H8C7.72386 11.5 7.5 11.2761 7.5 11Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 15C7.5 14.7239 7.72386 14.5 8 14.5H12C12.2761 14.5 12.5 14.7239 12.5 15C12.5 15.2761 12.2761 15.5 12 15.5H8C7.72386 15.5 7.5 15.2761 7.5 15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.32040f47b23da151c707c5e78e29ecbf.svg";
export { ForwardRef as ReactComponent };